// The supplier classification chosen on the Invite Vendor form. Mirrors
// vendorhub-backend/src/modules/approval-routing/classification.ts — keep the two in step.
export const NATURE_OF_BUSINESS = [
  { value: 'COMPONENT', label: 'Component' },
  { value: 'RAC_TAC_WAC', label: 'RAC / TAC / WAC' },
  { value: 'AIR_PURIFIER', label: 'Air Purifier' },
  { value: 'WATER_DISPENSER', label: 'Water Dispenser' },
  { value: 'FAN_DIVISION', label: 'Fan Division' },
];

export const OEM_ODM = [
  { value: 'OEM', label: 'OEM' },
  { value: 'ODM', label: 'ODM' },
];

// Direct and Indirect are both raw material (RM); RM and PM suppliers go through the quality gate.
export const SUPPLIER_SUBCATEGORY = [
  { value: 'DIRECT_RM', label: 'Direct – RM (raw material)', group: 'RM' },
  { value: 'INDIRECT_RM', label: 'Indirect – RM (raw material)', group: 'RM' },
  { value: 'PM', label: 'PM (packing material)', group: 'PM' },
  { value: 'HR', label: 'HR', group: 'HR' },
  { value: 'FINANCE', label: 'Finance', group: 'FINANCE' },
];

// What a routing rule can name for the sub-category ("RM" covers Direct and Indirect).
export const SUBCATEGORY_GROUPS = [
  { value: 'RM', label: 'RM (Direct or Indirect)' },
  { value: 'PM', label: 'PM (packing material)' },
  { value: 'HR', label: 'HR' },
  { value: 'FINANCE', label: 'Finance' },
];

const labelOf = (list, value, fallback = '—') => list.find((o) => o.value === value)?.label ?? (value || fallback);
export const natureLabel = (v) => labelOf(NATURE_OF_BUSINESS, v);
export const oemOdmLabel = (v) => labelOf(OEM_ODM, v);
export const subcategoryLabel = (v) => labelOf(SUPPLIER_SUBCATEGORY, v);
export const groupLabel = (v) => labelOf(SUBCATEGORY_GROUPS, v, 'Any');
export const needsQualityGate = (v) => ['RM', 'PM'].includes(SUPPLIER_SUBCATEGORY.find((s) => s.value === v)?.group);

/** "Soma Shekhar", "Soma Shekhar and Rishu Madaan", "A, B and C" — or the fallback when nobody is named. */
export const approverNames = (people, fallback = 'any administrator') => {
  const names = (people || []).map((p) => p?.full_name || p?.email).filter(Boolean);
  if (!names.length) return fallback;
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
};

/** Options for a filter dropdown: an "all" row first, then the list. */
export const withAll = (list, allLabel) => [{ value: '', label: allLabel }, ...list];

/** One line, e.g. "Component · OEM · Direct – RM (raw material)". */
export const classificationSummary = (obj) =>
  obj && (obj.nature_of_business || obj.oem_odm || obj.supplier_subcategory)
    ? [natureLabel(obj.nature_of_business), oemOdmLabel(obj.oem_odm), subcategoryLabel(obj.supplier_subcategory)].join(' · ')
    : 'Not classified';

/** The classification fields, as the API names them. */
export const CLASSIFICATION_FIELDS = ['nature_of_business', 'oem_odm', 'supplier_subcategory'];
export const EMPTY_CLASSIFICATION = { nature_of_business: '', oem_odm: '', supplier_subcategory: '' };

/** The classification part of an invite, a supplier request or a form, with '' for an answer not given. */
export const classificationOf = (obj) => ({
  nature_of_business: obj?.nature_of_business || '',
  oem_odm: obj?.oem_odm || '',
  supplier_subcategory: obj?.supplier_subcategory || '',
});

/** True once all three answers are given. */
export const isClassified = (obj) => CLASSIFICATION_FIELDS.every((field) => !!obj?.[field]);
